<script>

	export default {
		props: {
			centered: Boolean
		},
		render () {
			return <img src={require('./img/logo.svg')} class={['logo', { centered: this.centered }]} />
		}
	}

</script>

<style lang="scss" scoped>

	.logo {
		display:block; max-width:90px; height:auto;
		&.centered {
			margin-left:auto; margin-right:auto;
		}
	}

</style>



// WEBPACK FOOTER //
// src/routes/the-daily-sync/Logo/index.vue